// @flow
import React from 'react'

const BathTub = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
      <g fill="none" fillRule="evenodd" stroke="#6e7b8c" strokeLinecap="square">
        <path d="M5.5 18.5v2M17.5 18.5v2M.5 11.5v2c0 2.8 2.2 5 5 5h12c2.8 0 5-2.2 5-5v-2H.5zM22.5 11.5v-8c0-1.7-1.3-3-3-3s-3 1.3-3 3" />
        <path d="M19.5 6.5h-6c0-1.7 1.3-3 3-3s3 1.3 3 3z" />
      </g>
    </svg>
  )
}

export default BathTub



// WEBPACK FOOTER //
// ./src/components/Icons/BathTub.js